/*------------------------------------*\
	#FORM CONTROL VALIDATION
\*------------------------------------*/

const formControlValidation = () => {
	const selectorFormControlElements =
		'input.form-control, ' +
		'textarea.form-control, ' +
		'.form-group input[type=\'checkbox\'], ' +
		'select.form-control';
	const selectorUserInteraction = 'is-form__user-interact';
	const selectorVisited = 'is-valid';

	const elementFormControlList = document.querySelectorAll(selectorFormControlElements);

	let whenUserInteractWithField = (formField) => {
		return formField.value.length >= 1;
	}

	let userVisitedThisField = (field) => {
		field.classList.add(selectorVisited);
	}

	let userInteractWithFormControl = (formField) => {
		if (whenUserInteractWithField(formField)) {
			formField.classList.add(selectorUserInteraction);
		} else {
			formField.classList.remove(selectorUserInteraction);
		}
	}

	let createRequiredHelpBlockHtmlElement = (message) => {
		if (message) {
			const newDiv = document.createElement("div");
			newDiv.classList.add('is-render-from-validator', 'help-block', 'error');

			// and give it some content
			const newContent = document.createTextNode(message);

			// add the text node to the newly created div
			newDiv.appendChild(newContent);

			return newDiv

		} else {
			return null;
		}
	}

	let getRequiredMessage = (element) => {
		return element.dataset.requiredMessage;
	}

	let addHelpBlockTo = (element) => {
		const requiredMessage = getRequiredMessage(element);
		const requireDiv = createRequiredHelpBlockHtmlElement(requiredMessage);

		if (requireDiv) {
			// add requireDiv after form-control-item
			element.parentNode.appendChild(requireDiv);
		}
	}

	if (elementFormControlList) {
		elementFormControlList.forEach((formControlItem) => {

				addHelpBlockTo(formControlItem);

				formControlItem.addEventListener('blur', event => {
					userVisitedThisField(formControlItem)
				});
			}
		)
		elementFormControlList.forEach((formControlItem) => {
				formControlItem.addEventListener('input', event => {
					userInteractWithFormControl(formControlItem);
				});

			}
		)
	}
}

const meterReadingCustomErrorHandling = () => {
	document.querySelectorAll('.js-form-flattenedErrors .error[data-key]').forEach((ele) => {
		const key = ele.dataset.key
		let inputElements;
		switch (key) {
			case 'powercloud.save.reading.by.contract.id.invalid.parameter.value':
			case 'contractId':
				inputElements = document.querySelectorAll('form input[name*="contractId"]')
				break;
			case 'powercloud.save.reading.by.contract.id.digits.invalid.parameter.value':
			case 'powercloud.save.reading.by.contract.id.precision.invalid.parameter.value':
			case 'reading_usage_sum_is_not_plausible':
			case 'exists_previous_reading_with_higher_value':
				inputElements = document.querySelectorAll('form input[name*="meterReading"]')
				break;
			case 'powercloud.save.reading.by.contract.id.read.at.invalid.parameter.value':
				inputElements = document.querySelectorAll('form input[name*="meterDate"]')
				break;
			case 'counterNumber':
				inputElements = document.querySelectorAll('form input[name*="meterNumber"]')
				break;
		}
		inputElements.forEach((inputElement) => {
			inputElement.classList.add('is-invalid')
		});
	})
};

window.addEventListener('DOMContentLoaded', (event) => {
	formControlValidation();
	meterReadingCustomErrorHandling();
});
